/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchAssetRequest } from '../models';
// @ts-ignore
import type { BulkDeleteRequest } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { KGSearchResponse } from '../models';
// @ts-ignore
import type { RemoteFetchRequest } from '../models';
// @ts-ignore
import type { SimilarityResponse } from '../models';
// @ts-ignore
import type { StorageListResponse } from '../models';
// @ts-ignore
import type { StorageObjectResponse } from '../models';
// @ts-ignore
import type { StorageObjectUpdate } from '../models';
/**
 * StorageApi - axios parameter creator
 */
export const StorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Trigger async AI analysis and knowledge graph building for a storage object.  This endpoint starts async processing and returns immediately with a task ID. Use GET /storage/tasks/{task_id} to check progress.  Modes: - fast: Single flash model for everything (quick results) - quality: Flash for safety check, Pro with thinking for embeddings (best results)
         * @summary Analyze Async
         * @param {number} objectId 
         * @param {string} [mode] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeAsyncStorageAnalyzeAsyncObjectIdPost: async (objectId: number, mode?: string, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('analyzeAsyncStorageAnalyzeAsyncObjectIdPost', 'objectId', objectId)
            const localVarPath = `/storage/analyze-async/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyze Existing Object
         * @param {number} objectId 
         * @param {string | null} [aiContextText] Optional context hint for AI
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeExistingObjectStorageObjectsObjectIdAnalyzePost: async (objectId: number, aiContextText?: string | null, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('analyzeExistingObjectStorageObjectsObjectIdAnalyzePost', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/analyze`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aiContextText !== undefined) {
                localVarQueryParameter['ai_context_text'] = aiContextText;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes all storage objects matching the provided filters.
         * @summary Bulk Delete Filtered Objects
         * @param {BulkDeleteRequest} bulkDeleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFilteredObjectsStorageBulkDeletePost: async (bulkDeleteRequest: BulkDeleteRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteRequest' is not null or undefined
            assertParamExists('bulkDeleteFilteredObjectsStorageBulkDeletePost', 'bulkDeleteRequest', bulkDeleteRequest)
            const localVarPath = `/storage/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or refresh the knowledge graph embedding for a storage object.  Requires access to the object. Safe to call multiple times; replaces prior embedding.
         * @summary Create Embedding For Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmbeddingForObjectStorageObjectsObjectIdEmbedPost: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('createEmbeddingForObjectStorageObjectsObjectIdEmbedPost', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/embed`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete storage object (intuitive path with /objects/).
         * @summary Delete Object Alt
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteObjectAltStorageObjectsObjectIdDelete: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('deleteObjectAltStorageObjectsObjectIdDelete', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete storage object (legacy path without /objects/).
         * @summary Delete Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteObjectStorageObjectIdDelete: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('deleteObjectStorageObjectIdDelete', 'objectId', objectId)
            const localVarPath = `/storage/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download File
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStorageFilesObjectIdGet: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('downloadFileStorageFilesObjectIdGet', 'objectId', objectId)
            const localVarPath = `/storage/files/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch And Store Remote
         * @param {RemoteFetchRequest} remoteFetchRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAndStoreRemoteStorageFetchPost: async (remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'remoteFetchRequest' is not null or undefined
            assertParamExists('fetchAndStoreRemoteStorageFetchPost', 'remoteFetchRequest', remoteFetchRequest)
            const localVarPath = `/storage/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(remoteFetchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find semantically similar storage objects.  Uses vector embeddings to find objects with similar semantic content. Requires that the object has been analyzed with AI (analyze=true during upload).  Args:     object_id: ID of the storage object to find similar items for     limit: Maximum number of similar objects to return (1-50)  Returns:     SimilarityResponse with similar objects and their similarity scores
         * @summary Find Similar Objects
         * @param {number} objectId 
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSimilarObjectsStorageSimilarObjectIdGet: async (objectId: number, limit?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('findSimilarObjectsStorageSimilarObjectIdGet', 'objectId', objectId)
            const localVarPath = `/storage/similar/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch resolve asset variants for multiple link_ids.  This endpoint is optimized for performance when resolving many assets at once. Uses a single SQL query with IN clause instead of multiple individual queries.  Returns: Dict mapping link_id to asset data (same format as /asset-refs endpoint)
         * @summary Get Asset Variant References Batch
         * @param {BatchAssetRequest} batchAssetRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetVariantReferencesBatchStorageAssetRefsBatchPost: async (batchAssetRequest: BatchAssetRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchAssetRequest' is not null or undefined
            assertParamExists('getAssetVariantReferencesBatchStorageAssetRefsBatchPost', 'batchAssetRequest', batchAssetRequest)
            const localVarPath = `/storage/asset-refs/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchAssetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return simplified image/video variant URLs for use in design/print (e.g., Figma).  Mapping rules: - Images: thumb -> thumbnail_url, preview -> webview_url or thumbnail_url, print -> original file_url - Videos: hls -> detected master.m3u8, posterThumb -> thumbnail_url, posterPreview -> webview_url or thumbnail_url, print -> original file_url Access scope mirrors /storage/list: if link_id is provided we do not restrict by owner; otherwise owner-only unless admin with mine=false.
         * @summary Get Asset Variant References
         * @param {string | null} [linkId] Group assets by link; bypasses owner scope
         * @param {string | null} [collectionId] Filter by collection_id if link_id not provided
         * @param {number | null} [objectId] Pin to a specific storage object id
         * @param {string | null} [role] Filter by metadata_json.role (e.g., hero|detail|lifestyle)
         * @param {boolean} [mine] 
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetVariantReferencesStorageAssetRefsGet: async (linkId?: string | null, collectionId?: string | null, objectId?: number | null, role?: string | null, mine?: boolean, limit?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/asset-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (linkId !== undefined) {
                localVarQueryParameter['link_id'] = linkId;
            }

            if (collectionId !== undefined) {
                localVarQueryParameter['collection_id'] = collectionId;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['object_id'] = objectId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (mine !== undefined) {
                localVarQueryParameter['mine'] = mine;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current embedding text for a storage object.
         * @summary Get Embedding Text
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/embedding-text`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get knowledge graph statistics.  Returns:     Statistics about the knowledge graph including total embeddings,     collection name, and ChromaDB status.
         * @summary Get Kg Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKgStatsStorageKgStatsGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/kg/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Serve an optimized media variant directly.  Strategy: - If variant == thumbnail: serve existing thumbnail if present. - If variant == medium or display_for == figma-feed: serve or create a webview-sized derivative (~max 1920px), persist it, and return it. - If variant == full: stream original file. - width/height/format/quality can override defaults and will materialize a persistent derivative in webview dir.
         * @summary Get Media Variant
         * @param {number} objectId 
         * @param {string | null} [variant] thumbnail | medium | full
         * @param {string | null} [displayFor] e.g., figma-feed | web | print
         * @param {number | null} [width] 
         * @param {number | null} [height] 
         * @param {string | null} [format] jpg | png | webp
         * @param {number | null} [quality] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaVariantStorageMediaObjectIdGet: async (objectId: number, variant?: string | null, displayFor?: string | null, width?: number | null, height?: number | null, format?: string | null, quality?: number | null, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getMediaVariantStorageMediaObjectIdGet', 'objectId', objectId)
            const localVarPath = `/storage/media/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            if (displayFor !== undefined) {
                localVarQueryParameter['display_for'] = displayFor;
            }

            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }

            if (height !== undefined) {
                localVarQueryParameter['height'] = height;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (quality !== undefined) {
                localVarQueryParameter['quality'] = quality;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Object Metadata
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectMetadataStorageObjectsObjectIdGet: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getObjectMetadataStorageObjectsObjectIdGet', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get O\'Neal product enriched with Storage proxy URLs.  Returns O\'Neal API product data PLUS storage.proxy_url field. This allows Claude and other AI systems to access the cached proxy images.
         * @summary Get Oneal Product Enriched
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnealProductEnrichedStorageOnealProductsProductIdGet: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getOnealProductEnrichedStorageOnealProductsProductIdGet', 'productId', productId)
            const localVarPath = `/storage/oneal/products/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get real-time processing status for AI analysis. Shows chunking progress, current stage, timing info.
         * @summary Get Processing Status
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessingStatusStorageObjectsObjectIdProcessingStatusGet: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getProcessingStatusStorageObjectsObjectIdProcessingStatusGet', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/processing-status`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get external proxy cache statistics.  Admin-only endpoint to monitor cache performance.
         * @summary Get Proxy Cache Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProxyCacheStatsStorageProxyStatsGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/proxy/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get public storage object WITHOUT tenant filtering.  This endpoint is for public proxies and does NOT enforce tenant isolation. Only returns objects where is_public=True.  Use this for: - Public proxy access (share.arkturian.com/proxy.php) - Public embed links - Open API access
         * @summary Get Public Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicObjectStorageObjectsObjectIdPublicGet: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getPublicObjectStorageObjectsObjectIdPublicGet', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/public`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get status of an async processing task.  Returns task info including: - status: queued, processing, completed, failed - progress: 0-100 - current_phase: which phase is currently running - result: final results when completed - error: error message if failed
         * @summary Get Task Status
         * @param {string} taskId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStatusStorageTasksTaskIdGet: async (taskId: string, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTaskStatusStorageTasksTaskIdGet', 'taskId', taskId)
            const localVarPath = `/storage/tasks/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check for knowledge graph system.  Returns:     Health status including OpenAI configuration and ChromaDB connectivity.
         * @summary Kg Health Check
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kgHealthCheckStorageKgHealthGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/kg/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Semantic search across assets by text query using the Knowledge Graph vector store.  Scoping: - Admin: global unless mine=true, then owner-only - Non-admin: tenant-scoped by API key (preferred), else owner email domain; if mine=true, owner-only
         * @summary Kg Text Search
         * @param {string} query Text to search by
         * @param {number} [limit] 
         * @param {string | null} [collectionLike] Optional filter: collection id contains
         * @param {boolean} [mine] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kgTextSearchStorageKgSearchGet: async (query: string, limit?: number, collectionLike?: string | null, mine?: boolean, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('kgTextSearchStorageKgSearchGet', 'query', query)
            const localVarPath = `/storage/kg/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (collectionLike !== undefined) {
                localVarQueryParameter['collection_like'] = collectionLike;
            }

            if (mine !== undefined) {
                localVarQueryParameter['mine'] = mine;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Like Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeObjectStorageObjectsObjectIdLikePost: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('likeObjectStorageObjectsObjectIdLikePost', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/like`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Objects
         * @param {boolean} [mine] 
         * @param {string | null} [context] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [collectionLike] Case-insensitive contains filter for collection_id (use %25 for % wildcards)
         * @param {string | null} [linkId] 
         * @param {string | null} [ext] Filter by original_filename extension, e.g. \&#39;png\&#39;
         * @param {string | null} [name] Filter by filename (contains, case-insensitive)
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObjectsStorageListGet: async (mine?: boolean, context?: string | null, collectionId?: string | null, collectionLike?: string | null, linkId?: string | null, ext?: string | null, name?: string | null, limit?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mine !== undefined) {
                localVarQueryParameter['mine'] = mine;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (collectionId !== undefined) {
                localVarQueryParameter['collection_id'] = collectionId;
            }

            if (collectionLike !== undefined) {
                localVarQueryParameter['collection_like'] = collectionLike;
            }

            if (linkId !== undefined) {
                localVarQueryParameter['link_id'] = linkId;
            }

            if (ext !== undefined) {
                localVarQueryParameter['ext'] = ext;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List O\'Neal products enriched with Storage proxy URLs.
         * @summary List Oneal Products Enriched
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOnealProductsEnrichedStorageOnealProductsGet: async (limit?: number, offset?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/oneal/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all async processing tasks (most recent first).  Optional query parameters: - object_id: Filter tasks for a specific storage object  Useful for monitoring and debugging.
         * @summary List Tasks
         * @param {number} [limit] 
         * @param {number} [objectId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasksStorageTasksGet: async (limit?: number, objectId?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['object_id'] = objectId;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transparent proxy for external storage objects.  Fetches file from external URI (storage_mode=\"external\") with LRU caching. Returns the file data with appropriate headers.  Access control: - Owner can always access - Public files accessible to all - Admin can access all  Cache configuration (via environment): - EXTERNAL_CACHE_DIR: Cache directory - EXTERNAL_CACHE_MAX_SIZE_MB: Max cache size (default: 500MB) - EXTERNAL_CACHE_MAX_FILES: Max cached files (default: 1000) - EXTERNAL_CACHE_TTL_HOURS: Cache TTL (default: 24h)
         * @summary Proxy External File
         * @param {number} objectId 
         * @param {boolean} [noCache] Bypass cache and fetch fresh from source
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyExternalFileStorageProxyObjectIdGet: async (objectId: number, noCache?: boolean, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('proxyExternalFileStorageProxyObjectIdGet', 'objectId', objectId)
            const localVarPath = `/storage/proxy/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (noCache !== undefined) {
                localVarQueryParameter['no_cache'] = noCache;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace File
         * @param {number} objectId 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceFileStorageFilesObjectIdPut: async (objectId: number, file: File, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('replaceFileStorageFilesObjectIdPut', 'objectId', objectId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('replaceFileStorageFilesObjectIdPut', 'file', file)
            const localVarPath = `/storage/files/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the embedding text and regenerate the Knowledge Graph embedding.  Request body: {     \"embedding_text\": \"New descriptive text for semantic search...\" }
         * @summary Update Embedding Text
         * @param {number} objectId 
         * @param {object} body 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut: async (objectId: number, body: object, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut', 'objectId', objectId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut', 'body', body)
            const localVarPath = `/storage/objects/{object_id}/embedding-text`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Object Metadata
         * @param {number} objectId 
         * @param {StorageObjectUpdate} storageObjectUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObjectMetadataStorageObjectsObjectIdPatch: async (objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('updateObjectMetadataStorageObjectsObjectIdPatch', 'objectId', objectId)
            // verify required parameter 'storageObjectUpdate' is not null or undefined
            assertParamExists('updateObjectMetadataStorageObjectsObjectIdPatch', 'storageObjectUpdate', storageObjectUpdate)
            const localVarPath = `/storage/objects/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storageObjectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload File
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [context] 
         * @param {boolean} [isPublic] 
         * @param {string | null} [ownerEmail] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {boolean} [analyze] 
         * @param {string | null} [referenceId] 
         * @param {boolean} [hlsResult] 
         * @param {boolean} [skipAiSafety] 
         * @param {string} [storageMode] 
         * @param {string | null} [referencePath] 
         * @param {string | null} [externalUri] 
         * @param {string | null} [aiFilePath] 
         * @param {string | null} [aiMetadata] 
         * @param {string | null} [aiContextText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileStorageUploadPost: async (file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, skipAiSafety?: boolean, storageMode?: string, referencePath?: string | null, externalUri?: string | null, aiFilePath?: string | null, aiMetadata?: string | null, aiContextText?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFileStorageUploadPost', 'file', file)
            const localVarPath = `/storage/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (context !== undefined) { 
                localVarFormParams.append('context', context as any);
            }
    
            if (isPublic !== undefined) { 
                localVarFormParams.append('is_public', String(isPublic) as any);
            }
    
            if (ownerEmail !== undefined) { 
                localVarFormParams.append('owner_email', ownerEmail as any);
            }
    
            if (collectionId !== undefined) { 
                localVarFormParams.append('collection_id', collectionId as any);
            }
    
            if (linkId !== undefined) { 
                localVarFormParams.append('link_id', linkId as any);
            }
    
            if (analyze !== undefined) { 
                localVarFormParams.append('analyze', String(analyze) as any);
            }
    
            if (referenceId !== undefined) { 
                localVarFormParams.append('reference_id', referenceId as any);
            }
    
            if (hlsResult !== undefined) { 
                localVarFormParams.append('hls_result', String(hlsResult) as any);
            }
    
            if (skipAiSafety !== undefined) { 
                localVarFormParams.append('skip_ai_safety', String(skipAiSafety) as any);
            }
    
            if (storageMode !== undefined) { 
                localVarFormParams.append('storage_mode', storageMode as any);
            }
    
            if (referencePath !== undefined) { 
                localVarFormParams.append('reference_path', referencePath as any);
            }
    
            if (externalUri !== undefined) { 
                localVarFormParams.append('external_uri', externalUri as any);
            }
    
            if (aiFilePath !== undefined) { 
                localVarFormParams.append('ai_file_path', aiFilePath as any);
            }
    
            if (aiMetadata !== undefined) { 
                localVarFormParams.append('ai_metadata', aiMetadata as any);
            }
    
            if (aiContextText !== undefined) { 
                localVarFormParams.append('ai_context_text', aiContextText as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageApi - functional programming interface
 */
export const StorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageApiAxiosParamCreator(configuration)
    return {
        /**
         * Trigger async AI analysis and knowledge graph building for a storage object.  This endpoint starts async processing and returns immediately with a task ID. Use GET /storage/tasks/{task_id} to check progress.  Modes: - fast: Single flash model for everything (quick results) - quality: Flash for safety check, Pro with thinking for embeddings (best results)
         * @summary Analyze Async
         * @param {number} objectId 
         * @param {string} [mode] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeAsyncStorageAnalyzeAsyncObjectIdPost(objectId: number, mode?: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeAsyncStorageAnalyzeAsyncObjectIdPost(objectId, mode, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.analyzeAsyncStorageAnalyzeAsyncObjectIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Analyze Existing Object
         * @param {number} objectId 
         * @param {string | null} [aiContextText] Optional context hint for AI
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId: number, aiContextText?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId, aiContextText, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.analyzeExistingObjectStorageObjectsObjectIdAnalyzePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes all storage objects matching the provided filters.
         * @summary Bulk Delete Filtered Objects
         * @param {BulkDeleteRequest} bulkDeleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteFilteredObjectsStorageBulkDeletePost(bulkDeleteRequest: BulkDeleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteFilteredObjectsStorageBulkDeletePost(bulkDeleteRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.bulkDeleteFilteredObjectsStorageBulkDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or refresh the knowledge graph embedding for a storage object.  Requires access to the object. Safe to call multiple times; replaces prior embedding.
         * @summary Create Embedding For Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmbeddingForObjectStorageObjectsObjectIdEmbedPost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmbeddingForObjectStorageObjectsObjectIdEmbedPost(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.createEmbeddingForObjectStorageObjectsObjectIdEmbedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete storage object (intuitive path with /objects/).
         * @summary Delete Object Alt
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteObjectAltStorageObjectsObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteObjectAltStorageObjectsObjectIdDelete(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.deleteObjectAltStorageObjectsObjectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete storage object (legacy path without /objects/).
         * @summary Delete Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteObjectStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteObjectStorageObjectIdDelete(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.deleteObjectStorageObjectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download File
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileStorageFilesObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileStorageFilesObjectIdGet(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.downloadFileStorageFilesObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch And Store Remote
         * @param {RemoteFetchRequest} remoteFetchRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.fetchAndStoreRemoteStorageFetchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find semantically similar storage objects.  Uses vector embeddings to find objects with similar semantic content. Requires that the object has been analyzed with AI (analyze=true during upload).  Args:     object_id: ID of the storage object to find similar items for     limit: Maximum number of similar objects to return (1-50)  Returns:     SimilarityResponse with similar objects and their similarity scores
         * @summary Find Similar Objects
         * @param {number} objectId 
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSimilarObjectsStorageSimilarObjectIdGet(objectId: number, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimilarityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findSimilarObjectsStorageSimilarObjectIdGet(objectId, limit, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.findSimilarObjectsStorageSimilarObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch resolve asset variants for multiple link_ids.  This endpoint is optimized for performance when resolving many assets at once. Uses a single SQL query with IN clause instead of multiple individual queries.  Returns: Dict mapping link_id to asset data (same format as /asset-refs endpoint)
         * @summary Get Asset Variant References Batch
         * @param {BatchAssetRequest} batchAssetRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetVariantReferencesBatchStorageAssetRefsBatchPost(batchAssetRequest: BatchAssetRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetVariantReferencesBatchStorageAssetRefsBatchPost(batchAssetRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getAssetVariantReferencesBatchStorageAssetRefsBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return simplified image/video variant URLs for use in design/print (e.g., Figma).  Mapping rules: - Images: thumb -> thumbnail_url, preview -> webview_url or thumbnail_url, print -> original file_url - Videos: hls -> detected master.m3u8, posterThumb -> thumbnail_url, posterPreview -> webview_url or thumbnail_url, print -> original file_url Access scope mirrors /storage/list: if link_id is provided we do not restrict by owner; otherwise owner-only unless admin with mine=false.
         * @summary Get Asset Variant References
         * @param {string | null} [linkId] Group assets by link; bypasses owner scope
         * @param {string | null} [collectionId] Filter by collection_id if link_id not provided
         * @param {number | null} [objectId] Pin to a specific storage object id
         * @param {string | null} [role] Filter by metadata_json.role (e.g., hero|detail|lifestyle)
         * @param {boolean} [mine] 
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetVariantReferencesStorageAssetRefsGet(linkId?: string | null, collectionId?: string | null, objectId?: number | null, role?: string | null, mine?: boolean, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetVariantReferencesStorageAssetRefsGet(linkId, collectionId, objectId, role, mine, limit, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getAssetVariantReferencesStorageAssetRefsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current embedding text for a storage object.
         * @summary Get Embedding Text
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get knowledge graph statistics.  Returns:     Statistics about the knowledge graph including total embeddings,     collection name, and ChromaDB status.
         * @summary Get Kg Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKgStatsStorageKgStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKgStatsStorageKgStatsGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getKgStatsStorageKgStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Serve an optimized media variant directly.  Strategy: - If variant == thumbnail: serve existing thumbnail if present. - If variant == medium or display_for == figma-feed: serve or create a webview-sized derivative (~max 1920px), persist it, and return it. - If variant == full: stream original file. - width/height/format/quality can override defaults and will materialize a persistent derivative in webview dir.
         * @summary Get Media Variant
         * @param {number} objectId 
         * @param {string | null} [variant] thumbnail | medium | full
         * @param {string | null} [displayFor] e.g., figma-feed | web | print
         * @param {number | null} [width] 
         * @param {number | null} [height] 
         * @param {string | null} [format] jpg | png | webp
         * @param {number | null} [quality] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaVariantStorageMediaObjectIdGet(objectId: number, variant?: string | null, displayFor?: string | null, width?: number | null, height?: number | null, format?: string | null, quality?: number | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaVariantStorageMediaObjectIdGet(objectId, variant, displayFor, width, height, format, quality, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getMediaVariantStorageMediaObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Object Metadata
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObjectMetadataStorageObjectsObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObjectMetadataStorageObjectsObjectIdGet(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getObjectMetadataStorageObjectsObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get O\'Neal product enriched with Storage proxy URLs.  Returns O\'Neal API product data PLUS storage.proxy_url field. This allows Claude and other AI systems to access the cached proxy images.
         * @summary Get Oneal Product Enriched
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnealProductEnrichedStorageOnealProductsProductIdGet(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnealProductEnrichedStorageOnealProductsProductIdGet(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getOnealProductEnrichedStorageOnealProductsProductIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get real-time processing status for AI analysis. Shows chunking progress, current stage, timing info.
         * @summary Get Processing Status
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessingStatusStorageObjectsObjectIdProcessingStatusGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessingStatusStorageObjectsObjectIdProcessingStatusGet(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getProcessingStatusStorageObjectsObjectIdProcessingStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get external proxy cache statistics.  Admin-only endpoint to monitor cache performance.
         * @summary Get Proxy Cache Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProxyCacheStatsStorageProxyStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProxyCacheStatsStorageProxyStatsGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getProxyCacheStatsStorageProxyStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get public storage object WITHOUT tenant filtering.  This endpoint is for public proxies and does NOT enforce tenant isolation. Only returns objects where is_public=True.  Use this for: - Public proxy access (share.arkturian.com/proxy.php) - Public embed links - Open API access
         * @summary Get Public Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicObjectStorageObjectsObjectIdPublicGet(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicObjectStorageObjectsObjectIdPublicGet(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getPublicObjectStorageObjectsObjectIdPublicGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get status of an async processing task.  Returns task info including: - status: queued, processing, completed, failed - progress: 0-100 - current_phase: which phase is currently running - result: final results when completed - error: error message if failed
         * @summary Get Task Status
         * @param {string} taskId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskStatusStorageTasksTaskIdGet(taskId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskStatusStorageTasksTaskIdGet(taskId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getTaskStatusStorageTasksTaskIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check for knowledge graph system.  Returns:     Health status including OpenAI configuration and ChromaDB connectivity.
         * @summary Kg Health Check
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kgHealthCheckStorageKgHealthGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kgHealthCheckStorageKgHealthGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.kgHealthCheckStorageKgHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Semantic search across assets by text query using the Knowledge Graph vector store.  Scoping: - Admin: global unless mine=true, then owner-only - Non-admin: tenant-scoped by API key (preferred), else owner email domain; if mine=true, owner-only
         * @summary Kg Text Search
         * @param {string} query Text to search by
         * @param {number} [limit] 
         * @param {string | null} [collectionLike] Optional filter: collection id contains
         * @param {boolean} [mine] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kgTextSearchStorageKgSearchGet(query: string, limit?: number, collectionLike?: string | null, mine?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KGSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kgTextSearchStorageKgSearchGet(query, limit, collectionLike, mine, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.kgTextSearchStorageKgSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Like Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async likeObjectStorageObjectsObjectIdLikePost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.likeObjectStorageObjectsObjectIdLikePost(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.likeObjectStorageObjectsObjectIdLikePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Objects
         * @param {boolean} [mine] 
         * @param {string | null} [context] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [collectionLike] Case-insensitive contains filter for collection_id (use %25 for % wildcards)
         * @param {string | null} [linkId] 
         * @param {string | null} [ext] Filter by original_filename extension, e.g. \&#39;png\&#39;
         * @param {string | null} [name] Filter by filename (contains, case-insensitive)
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listObjectsStorageListGet(mine?: boolean, context?: string | null, collectionId?: string | null, collectionLike?: string | null, linkId?: string | null, ext?: string | null, name?: string | null, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listObjectsStorageListGet(mine, context, collectionId, collectionLike, linkId, ext, name, limit, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.listObjectsStorageListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List O\'Neal products enriched with Storage proxy URLs.
         * @summary List Oneal Products Enriched
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOnealProductsEnrichedStorageOnealProductsGet(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOnealProductsEnrichedStorageOnealProductsGet(limit, offset, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.listOnealProductsEnrichedStorageOnealProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all async processing tasks (most recent first).  Optional query parameters: - object_id: Filter tasks for a specific storage object  Useful for monitoring and debugging.
         * @summary List Tasks
         * @param {number} [limit] 
         * @param {number} [objectId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTasksStorageTasksGet(limit?: number, objectId?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTasksStorageTasksGet(limit, objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.listTasksStorageTasksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transparent proxy for external storage objects.  Fetches file from external URI (storage_mode=\"external\") with LRU caching. Returns the file data with appropriate headers.  Access control: - Owner can always access - Public files accessible to all - Admin can access all  Cache configuration (via environment): - EXTERNAL_CACHE_DIR: Cache directory - EXTERNAL_CACHE_MAX_SIZE_MB: Max cache size (default: 500MB) - EXTERNAL_CACHE_MAX_FILES: Max cached files (default: 1000) - EXTERNAL_CACHE_TTL_HOURS: Cache TTL (default: 24h)
         * @summary Proxy External File
         * @param {number} objectId 
         * @param {boolean} [noCache] Bypass cache and fetch fresh from source
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxyExternalFileStorageProxyObjectIdGet(objectId: number, noCache?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proxyExternalFileStorageProxyObjectIdGet(objectId, noCache, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.proxyExternalFileStorageProxyObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace File
         * @param {number} objectId 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceFileStorageFilesObjectIdPut(objectId: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceFileStorageFilesObjectIdPut(objectId, file, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.replaceFileStorageFilesObjectIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the embedding text and regenerate the Knowledge Graph embedding.  Request body: {     \"embedding_text\": \"New descriptive text for semantic search...\" }
         * @summary Update Embedding Text
         * @param {number} objectId 
         * @param {object} body 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut(objectId: number, body: object, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut(objectId, body, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Object Metadata
         * @param {number} objectId 
         * @param {StorageObjectUpdate} storageObjectUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateObjectMetadataStorageObjectsObjectIdPatch(objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateObjectMetadataStorageObjectsObjectIdPatch(objectId, storageObjectUpdate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.updateObjectMetadataStorageObjectsObjectIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload File
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [context] 
         * @param {boolean} [isPublic] 
         * @param {string | null} [ownerEmail] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {boolean} [analyze] 
         * @param {string | null} [referenceId] 
         * @param {boolean} [hlsResult] 
         * @param {boolean} [skipAiSafety] 
         * @param {string} [storageMode] 
         * @param {string | null} [referencePath] 
         * @param {string | null} [externalUri] 
         * @param {string | null} [aiFilePath] 
         * @param {string | null} [aiMetadata] 
         * @param {string | null} [aiContextText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileStorageUploadPost(file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, skipAiSafety?: boolean, storageMode?: string, referencePath?: string | null, externalUri?: string | null, aiFilePath?: string | null, aiMetadata?: string | null, aiContextText?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFileStorageUploadPost(file, xAPIKEY, context, isPublic, ownerEmail, collectionId, linkId, analyze, referenceId, hlsResult, skipAiSafety, storageMode, referencePath, externalUri, aiFilePath, aiMetadata, aiContextText, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.uploadFileStorageUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorageApi - factory interface
 */
export const StorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageApiFp(configuration)
    return {
        /**
         * Trigger async AI analysis and knowledge graph building for a storage object.  This endpoint starts async processing and returns immediately with a task ID. Use GET /storage/tasks/{task_id} to check progress.  Modes: - fast: Single flash model for everything (quick results) - quality: Flash for safety check, Pro with thinking for embeddings (best results)
         * @summary Analyze Async
         * @param {number} objectId 
         * @param {string} [mode] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeAsyncStorageAnalyzeAsyncObjectIdPost(objectId: number, mode?: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.analyzeAsyncStorageAnalyzeAsyncObjectIdPost(objectId, mode, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyze Existing Object
         * @param {number} objectId 
         * @param {string | null} [aiContextText] Optional context hint for AI
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId: number, aiContextText?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId, aiContextText, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes all storage objects matching the provided filters.
         * @summary Bulk Delete Filtered Objects
         * @param {BulkDeleteRequest} bulkDeleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFilteredObjectsStorageBulkDeletePost(bulkDeleteRequest: BulkDeleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bulkDeleteFilteredObjectsStorageBulkDeletePost(bulkDeleteRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or refresh the knowledge graph embedding for a storage object.  Requires access to the object. Safe to call multiple times; replaces prior embedding.
         * @summary Create Embedding For Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmbeddingForObjectStorageObjectsObjectIdEmbedPost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.createEmbeddingForObjectStorageObjectsObjectIdEmbedPost(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete storage object (intuitive path with /objects/).
         * @summary Delete Object Alt
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteObjectAltStorageObjectsObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteObjectAltStorageObjectsObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete storage object (legacy path without /objects/).
         * @summary Delete Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteObjectStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteObjectStorageObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download File
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStorageFilesObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadFileStorageFilesObjectIdGet(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch And Store Remote
         * @param {RemoteFetchRequest} remoteFetchRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Find semantically similar storage objects.  Uses vector embeddings to find objects with similar semantic content. Requires that the object has been analyzed with AI (analyze=true during upload).  Args:     object_id: ID of the storage object to find similar items for     limit: Maximum number of similar objects to return (1-50)  Returns:     SimilarityResponse with similar objects and their similarity scores
         * @summary Find Similar Objects
         * @param {number} objectId 
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSimilarObjectsStorageSimilarObjectIdGet(objectId: number, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<SimilarityResponse> {
            return localVarFp.findSimilarObjectsStorageSimilarObjectIdGet(objectId, limit, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch resolve asset variants for multiple link_ids.  This endpoint is optimized for performance when resolving many assets at once. Uses a single SQL query with IN clause instead of multiple individual queries.  Returns: Dict mapping link_id to asset data (same format as /asset-refs endpoint)
         * @summary Get Asset Variant References Batch
         * @param {BatchAssetRequest} batchAssetRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetVariantReferencesBatchStorageAssetRefsBatchPost(batchAssetRequest: BatchAssetRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAssetVariantReferencesBatchStorageAssetRefsBatchPost(batchAssetRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Return simplified image/video variant URLs for use in design/print (e.g., Figma).  Mapping rules: - Images: thumb -> thumbnail_url, preview -> webview_url or thumbnail_url, print -> original file_url - Videos: hls -> detected master.m3u8, posterThumb -> thumbnail_url, posterPreview -> webview_url or thumbnail_url, print -> original file_url Access scope mirrors /storage/list: if link_id is provided we do not restrict by owner; otherwise owner-only unless admin with mine=false.
         * @summary Get Asset Variant References
         * @param {string | null} [linkId] Group assets by link; bypasses owner scope
         * @param {string | null} [collectionId] Filter by collection_id if link_id not provided
         * @param {number | null} [objectId] Pin to a specific storage object id
         * @param {string | null} [role] Filter by metadata_json.role (e.g., hero|detail|lifestyle)
         * @param {boolean} [mine] 
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetVariantReferencesStorageAssetRefsGet(linkId?: string | null, collectionId?: string | null, objectId?: number | null, role?: string | null, mine?: boolean, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAssetVariantReferencesStorageAssetRefsGet(linkId, collectionId, objectId, role, mine, limit, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current embedding text for a storage object.
         * @summary Get Embedding Text
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get knowledge graph statistics.  Returns:     Statistics about the knowledge graph including total embeddings,     collection name, and ChromaDB status.
         * @summary Get Kg Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKgStatsStorageKgStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getKgStatsStorageKgStatsGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Serve an optimized media variant directly.  Strategy: - If variant == thumbnail: serve existing thumbnail if present. - If variant == medium or display_for == figma-feed: serve or create a webview-sized derivative (~max 1920px), persist it, and return it. - If variant == full: stream original file. - width/height/format/quality can override defaults and will materialize a persistent derivative in webview dir.
         * @summary Get Media Variant
         * @param {number} objectId 
         * @param {string | null} [variant] thumbnail | medium | full
         * @param {string | null} [displayFor] e.g., figma-feed | web | print
         * @param {number | null} [width] 
         * @param {number | null} [height] 
         * @param {string | null} [format] jpg | png | webp
         * @param {number | null} [quality] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaVariantStorageMediaObjectIdGet(objectId: number, variant?: string | null, displayFor?: string | null, width?: number | null, height?: number | null, format?: string | null, quality?: number | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getMediaVariantStorageMediaObjectIdGet(objectId, variant, displayFor, width, height, format, quality, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Object Metadata
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectMetadataStorageObjectsObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.getObjectMetadataStorageObjectsObjectIdGet(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get O\'Neal product enriched with Storage proxy URLs.  Returns O\'Neal API product data PLUS storage.proxy_url field. This allows Claude and other AI systems to access the cached proxy images.
         * @summary Get Oneal Product Enriched
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnealProductEnrichedStorageOnealProductsProductIdGet(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getOnealProductEnrichedStorageOnealProductsProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get real-time processing status for AI analysis. Shows chunking progress, current stage, timing info.
         * @summary Get Processing Status
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessingStatusStorageObjectsObjectIdProcessingStatusGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getProcessingStatusStorageObjectsObjectIdProcessingStatusGet(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get external proxy cache statistics.  Admin-only endpoint to monitor cache performance.
         * @summary Get Proxy Cache Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProxyCacheStatsStorageProxyStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getProxyCacheStatsStorageProxyStatsGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get public storage object WITHOUT tenant filtering.  This endpoint is for public proxies and does NOT enforce tenant isolation. Only returns objects where is_public=True.  Use this for: - Public proxy access (share.arkturian.com/proxy.php) - Public embed links - Open API access
         * @summary Get Public Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicObjectStorageObjectsObjectIdPublicGet(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.getPublicObjectStorageObjectsObjectIdPublicGet(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get status of an async processing task.  Returns task info including: - status: queued, processing, completed, failed - progress: 0-100 - current_phase: which phase is currently running - result: final results when completed - error: error message if failed
         * @summary Get Task Status
         * @param {string} taskId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStatusStorageTasksTaskIdGet(taskId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTaskStatusStorageTasksTaskIdGet(taskId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Health check for knowledge graph system.  Returns:     Health status including OpenAI configuration and ChromaDB connectivity.
         * @summary Kg Health Check
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kgHealthCheckStorageKgHealthGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.kgHealthCheckStorageKgHealthGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Semantic search across assets by text query using the Knowledge Graph vector store.  Scoping: - Admin: global unless mine=true, then owner-only - Non-admin: tenant-scoped by API key (preferred), else owner email domain; if mine=true, owner-only
         * @summary Kg Text Search
         * @param {string} query Text to search by
         * @param {number} [limit] 
         * @param {string | null} [collectionLike] Optional filter: collection id contains
         * @param {boolean} [mine] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kgTextSearchStorageKgSearchGet(query: string, limit?: number, collectionLike?: string | null, mine?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<KGSearchResponse> {
            return localVarFp.kgTextSearchStorageKgSearchGet(query, limit, collectionLike, mine, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Like Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeObjectStorageObjectsObjectIdLikePost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.likeObjectStorageObjectsObjectIdLikePost(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Objects
         * @param {boolean} [mine] 
         * @param {string | null} [context] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [collectionLike] Case-insensitive contains filter for collection_id (use %25 for % wildcards)
         * @param {string | null} [linkId] 
         * @param {string | null} [ext] Filter by original_filename extension, e.g. \&#39;png\&#39;
         * @param {string | null} [name] Filter by filename (contains, case-insensitive)
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObjectsStorageListGet(mine?: boolean, context?: string | null, collectionId?: string | null, collectionLike?: string | null, linkId?: string | null, ext?: string | null, name?: string | null, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageListResponse> {
            return localVarFp.listObjectsStorageListGet(mine, context, collectionId, collectionLike, linkId, ext, name, limit, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * List O\'Neal products enriched with Storage proxy URLs.
         * @summary List Oneal Products Enriched
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOnealProductsEnrichedStorageOnealProductsGet(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.listOnealProductsEnrichedStorageOnealProductsGet(limit, offset, search, options).then((request) => request(axios, basePath));
        },
        /**
         * List all async processing tasks (most recent first).  Optional query parameters: - object_id: Filter tasks for a specific storage object  Useful for monitoring and debugging.
         * @summary List Tasks
         * @param {number} [limit] 
         * @param {number} [objectId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasksStorageTasksGet(limit?: number, objectId?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.listTasksStorageTasksGet(limit, objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Transparent proxy for external storage objects.  Fetches file from external URI (storage_mode=\"external\") with LRU caching. Returns the file data with appropriate headers.  Access control: - Owner can always access - Public files accessible to all - Admin can access all  Cache configuration (via environment): - EXTERNAL_CACHE_DIR: Cache directory - EXTERNAL_CACHE_MAX_SIZE_MB: Max cache size (default: 500MB) - EXTERNAL_CACHE_MAX_FILES: Max cached files (default: 1000) - EXTERNAL_CACHE_TTL_HOURS: Cache TTL (default: 24h)
         * @summary Proxy External File
         * @param {number} objectId 
         * @param {boolean} [noCache] Bypass cache and fetch fresh from source
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyExternalFileStorageProxyObjectIdGet(objectId: number, noCache?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.proxyExternalFileStorageProxyObjectIdGet(objectId, noCache, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace File
         * @param {number} objectId 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceFileStorageFilesObjectIdPut(objectId: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.replaceFileStorageFilesObjectIdPut(objectId, file, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the embedding text and regenerate the Knowledge Graph embedding.  Request body: {     \"embedding_text\": \"New descriptive text for semantic search...\" }
         * @summary Update Embedding Text
         * @param {number} objectId 
         * @param {object} body 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut(objectId: number, body: object, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut(objectId, body, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Object Metadata
         * @param {number} objectId 
         * @param {StorageObjectUpdate} storageObjectUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObjectMetadataStorageObjectsObjectIdPatch(objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.updateObjectMetadataStorageObjectsObjectIdPatch(objectId, storageObjectUpdate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload File
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [context] 
         * @param {boolean} [isPublic] 
         * @param {string | null} [ownerEmail] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {boolean} [analyze] 
         * @param {string | null} [referenceId] 
         * @param {boolean} [hlsResult] 
         * @param {boolean} [skipAiSafety] 
         * @param {string} [storageMode] 
         * @param {string | null} [referencePath] 
         * @param {string | null} [externalUri] 
         * @param {string | null} [aiFilePath] 
         * @param {string | null} [aiMetadata] 
         * @param {string | null} [aiContextText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileStorageUploadPost(file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, skipAiSafety?: boolean, storageMode?: string, referencePath?: string | null, externalUri?: string | null, aiFilePath?: string | null, aiMetadata?: string | null, aiContextText?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.uploadFileStorageUploadPost(file, xAPIKEY, context, isPublic, ownerEmail, collectionId, linkId, analyze, referenceId, hlsResult, skipAiSafety, storageMode, referencePath, externalUri, aiFilePath, aiMetadata, aiContextText, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorageApi - interface
 */
export interface StorageApiInterface {
    /**
     * Trigger async AI analysis and knowledge graph building for a storage object.  This endpoint starts async processing and returns immediately with a task ID. Use GET /storage/tasks/{task_id} to check progress.  Modes: - fast: Single flash model for everything (quick results) - quality: Flash for safety check, Pro with thinking for embeddings (best results)
     * @summary Analyze Async
     * @param {number} objectId 
     * @param {string} [mode] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyzeAsyncStorageAnalyzeAsyncObjectIdPost(objectId: number, mode?: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Analyze Existing Object
     * @param {number} objectId 
     * @param {string | null} [aiContextText] Optional context hint for AI
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId: number, aiContextText?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * Deletes all storage objects matching the provided filters.
     * @summary Bulk Delete Filtered Objects
     * @param {BulkDeleteRequest} bulkDeleteRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkDeleteFilteredObjectsStorageBulkDeletePost(bulkDeleteRequest: BulkDeleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Create or refresh the knowledge graph embedding for a storage object.  Requires access to the object. Safe to call multiple times; replaces prior embedding.
     * @summary Create Embedding For Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmbeddingForObjectStorageObjectsObjectIdEmbedPost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * Delete storage object (intuitive path with /objects/).
     * @summary Delete Object Alt
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteObjectAltStorageObjectsObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Delete storage object (legacy path without /objects/).
     * @summary Delete Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteObjectStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Download File
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadFileStorageFilesObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Fetch And Store Remote
     * @param {RemoteFetchRequest} remoteFetchRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * Find semantically similar storage objects.  Uses vector embeddings to find objects with similar semantic content. Requires that the object has been analyzed with AI (analyze=true during upload).  Args:     object_id: ID of the storage object to find similar items for     limit: Maximum number of similar objects to return (1-50)  Returns:     SimilarityResponse with similar objects and their similarity scores
     * @summary Find Similar Objects
     * @param {number} objectId 
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findSimilarObjectsStorageSimilarObjectIdGet(objectId: number, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<SimilarityResponse>;

    /**
     * Batch resolve asset variants for multiple link_ids.  This endpoint is optimized for performance when resolving many assets at once. Uses a single SQL query with IN clause instead of multiple individual queries.  Returns: Dict mapping link_id to asset data (same format as /asset-refs endpoint)
     * @summary Get Asset Variant References Batch
     * @param {BatchAssetRequest} batchAssetRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssetVariantReferencesBatchStorageAssetRefsBatchPost(batchAssetRequest: BatchAssetRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Return simplified image/video variant URLs for use in design/print (e.g., Figma).  Mapping rules: - Images: thumb -> thumbnail_url, preview -> webview_url or thumbnail_url, print -> original file_url - Videos: hls -> detected master.m3u8, posterThumb -> thumbnail_url, posterPreview -> webview_url or thumbnail_url, print -> original file_url Access scope mirrors /storage/list: if link_id is provided we do not restrict by owner; otherwise owner-only unless admin with mine=false.
     * @summary Get Asset Variant References
     * @param {string | null} [linkId] Group assets by link; bypasses owner scope
     * @param {string | null} [collectionId] Filter by collection_id if link_id not provided
     * @param {number | null} [objectId] Pin to a specific storage object id
     * @param {string | null} [role] Filter by metadata_json.role (e.g., hero|detail|lifestyle)
     * @param {boolean} [mine] 
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssetVariantReferencesStorageAssetRefsGet(linkId?: string | null, collectionId?: string | null, objectId?: number | null, role?: string | null, mine?: boolean, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Get the current embedding text for a storage object.
     * @summary Get Embedding Text
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Get knowledge graph statistics.  Returns:     Statistics about the knowledge graph including total embeddings,     collection name, and ChromaDB status.
     * @summary Get Kg Stats
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKgStatsStorageKgStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Serve an optimized media variant directly.  Strategy: - If variant == thumbnail: serve existing thumbnail if present. - If variant == medium or display_for == figma-feed: serve or create a webview-sized derivative (~max 1920px), persist it, and return it. - If variant == full: stream original file. - width/height/format/quality can override defaults and will materialize a persistent derivative in webview dir.
     * @summary Get Media Variant
     * @param {number} objectId 
     * @param {string | null} [variant] thumbnail | medium | full
     * @param {string | null} [displayFor] e.g., figma-feed | web | print
     * @param {number | null} [width] 
     * @param {number | null} [height] 
     * @param {string | null} [format] jpg | png | webp
     * @param {number | null} [quality] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMediaVariantStorageMediaObjectIdGet(objectId: number, variant?: string | null, displayFor?: string | null, width?: number | null, height?: number | null, format?: string | null, quality?: number | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Get Object Metadata
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getObjectMetadataStorageObjectsObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * Get O\'Neal product enriched with Storage proxy URLs.  Returns O\'Neal API product data PLUS storage.proxy_url field. This allows Claude and other AI systems to access the cached proxy images.
     * @summary Get Oneal Product Enriched
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnealProductEnrichedStorageOnealProductsProductIdGet(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Get real-time processing status for AI analysis. Shows chunking progress, current stage, timing info.
     * @summary Get Processing Status
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessingStatusStorageObjectsObjectIdProcessingStatusGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Get external proxy cache statistics.  Admin-only endpoint to monitor cache performance.
     * @summary Get Proxy Cache Stats
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProxyCacheStatsStorageProxyStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Get public storage object WITHOUT tenant filtering.  This endpoint is for public proxies and does NOT enforce tenant isolation. Only returns objects where is_public=True.  Use this for: - Public proxy access (share.arkturian.com/proxy.php) - Public embed links - Open API access
     * @summary Get Public Object
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicObjectStorageObjectsObjectIdPublicGet(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * Get status of an async processing task.  Returns task info including: - status: queued, processing, completed, failed - progress: 0-100 - current_phase: which phase is currently running - result: final results when completed - error: error message if failed
     * @summary Get Task Status
     * @param {string} taskId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskStatusStorageTasksTaskIdGet(taskId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Health check for knowledge graph system.  Returns:     Health status including OpenAI configuration and ChromaDB connectivity.
     * @summary Kg Health Check
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kgHealthCheckStorageKgHealthGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Semantic search across assets by text query using the Knowledge Graph vector store.  Scoping: - Admin: global unless mine=true, then owner-only - Non-admin: tenant-scoped by API key (preferred), else owner email domain; if mine=true, owner-only
     * @summary Kg Text Search
     * @param {string} query Text to search by
     * @param {number} [limit] 
     * @param {string | null} [collectionLike] Optional filter: collection id contains
     * @param {boolean} [mine] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kgTextSearchStorageKgSearchGet(query: string, limit?: number, collectionLike?: string | null, mine?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<KGSearchResponse>;

    /**
     * 
     * @summary Like Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    likeObjectStorageObjectsObjectIdLikePost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * 
     * @summary List Objects
     * @param {boolean} [mine] 
     * @param {string | null} [context] 
     * @param {string | null} [collectionId] 
     * @param {string | null} [collectionLike] Case-insensitive contains filter for collection_id (use %25 for % wildcards)
     * @param {string | null} [linkId] 
     * @param {string | null} [ext] Filter by original_filename extension, e.g. \&#39;png\&#39;
     * @param {string | null} [name] Filter by filename (contains, case-insensitive)
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listObjectsStorageListGet(mine?: boolean, context?: string | null, collectionId?: string | null, collectionLike?: string | null, linkId?: string | null, ext?: string | null, name?: string | null, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageListResponse>;

    /**
     * List O\'Neal products enriched with Storage proxy URLs.
     * @summary List Oneal Products Enriched
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOnealProductsEnrichedStorageOnealProductsGet(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * List all async processing tasks (most recent first).  Optional query parameters: - object_id: Filter tasks for a specific storage object  Useful for monitoring and debugging.
     * @summary List Tasks
     * @param {number} [limit] 
     * @param {number} [objectId] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTasksStorageTasksGet(limit?: number, objectId?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Transparent proxy for external storage objects.  Fetches file from external URI (storage_mode=\"external\") with LRU caching. Returns the file data with appropriate headers.  Access control: - Owner can always access - Public files accessible to all - Admin can access all  Cache configuration (via environment): - EXTERNAL_CACHE_DIR: Cache directory - EXTERNAL_CACHE_MAX_SIZE_MB: Max cache size (default: 500MB) - EXTERNAL_CACHE_MAX_FILES: Max cached files (default: 1000) - EXTERNAL_CACHE_TTL_HOURS: Cache TTL (default: 24h)
     * @summary Proxy External File
     * @param {number} objectId 
     * @param {boolean} [noCache] Bypass cache and fetch fresh from source
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    proxyExternalFileStorageProxyObjectIdGet(objectId: number, noCache?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Replace File
     * @param {number} objectId 
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    replaceFileStorageFilesObjectIdPut(objectId: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * Update the embedding text and regenerate the Knowledge Graph embedding.  Request body: {     \"embedding_text\": \"New descriptive text for semantic search...\" }
     * @summary Update Embedding Text
     * @param {number} objectId 
     * @param {object} body 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut(objectId: number, body: object, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Update Object Metadata
     * @param {number} objectId 
     * @param {StorageObjectUpdate} storageObjectUpdate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateObjectMetadataStorageObjectsObjectIdPatch(objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

    /**
     * 
     * @summary Upload File
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {string | null} [context] 
     * @param {boolean} [isPublic] 
     * @param {string | null} [ownerEmail] 
     * @param {string | null} [collectionId] 
     * @param {string | null} [linkId] 
     * @param {boolean} [analyze] 
     * @param {string | null} [referenceId] 
     * @param {boolean} [hlsResult] 
     * @param {boolean} [skipAiSafety] 
     * @param {string} [storageMode] 
     * @param {string | null} [referencePath] 
     * @param {string | null} [externalUri] 
     * @param {string | null} [aiFilePath] 
     * @param {string | null} [aiMetadata] 
     * @param {string | null} [aiContextText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFileStorageUploadPost(file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, skipAiSafety?: boolean, storageMode?: string, referencePath?: string | null, externalUri?: string | null, aiFilePath?: string | null, aiMetadata?: string | null, aiContextText?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse>;

}

/**
 * StorageApi - object-oriented interface
 */
export class StorageApi extends BaseAPI implements StorageApiInterface {
    /**
     * Trigger async AI analysis and knowledge graph building for a storage object.  This endpoint starts async processing and returns immediately with a task ID. Use GET /storage/tasks/{task_id} to check progress.  Modes: - fast: Single flash model for everything (quick results) - quality: Flash for safety check, Pro with thinking for embeddings (best results)
     * @summary Analyze Async
     * @param {number} objectId 
     * @param {string} [mode] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public analyzeAsyncStorageAnalyzeAsyncObjectIdPost(objectId: number, mode?: string, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).analyzeAsyncStorageAnalyzeAsyncObjectIdPost(objectId, mode, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyze Existing Object
     * @param {number} objectId 
     * @param {string | null} [aiContextText] Optional context hint for AI
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId: number, aiContextText?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId, aiContextText, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes all storage objects matching the provided filters.
     * @summary Bulk Delete Filtered Objects
     * @param {BulkDeleteRequest} bulkDeleteRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkDeleteFilteredObjectsStorageBulkDeletePost(bulkDeleteRequest: BulkDeleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).bulkDeleteFilteredObjectsStorageBulkDeletePost(bulkDeleteRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or refresh the knowledge graph embedding for a storage object.  Requires access to the object. Safe to call multiple times; replaces prior embedding.
     * @summary Create Embedding For Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEmbeddingForObjectStorageObjectsObjectIdEmbedPost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).createEmbeddingForObjectStorageObjectsObjectIdEmbedPost(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete storage object (intuitive path with /objects/).
     * @summary Delete Object Alt
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteObjectAltStorageObjectsObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).deleteObjectAltStorageObjectsObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete storage object (legacy path without /objects/).
     * @summary Delete Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteObjectStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).deleteObjectStorageObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download File
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadFileStorageFilesObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).downloadFileStorageFilesObjectIdGet(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch And Store Remote
     * @param {RemoteFetchRequest} remoteFetchRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find semantically similar storage objects.  Uses vector embeddings to find objects with similar semantic content. Requires that the object has been analyzed with AI (analyze=true during upload).  Args:     object_id: ID of the storage object to find similar items for     limit: Maximum number of similar objects to return (1-50)  Returns:     SimilarityResponse with similar objects and their similarity scores
     * @summary Find Similar Objects
     * @param {number} objectId 
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findSimilarObjectsStorageSimilarObjectIdGet(objectId: number, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).findSimilarObjectsStorageSimilarObjectIdGet(objectId, limit, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch resolve asset variants for multiple link_ids.  This endpoint is optimized for performance when resolving many assets at once. Uses a single SQL query with IN clause instead of multiple individual queries.  Returns: Dict mapping link_id to asset data (same format as /asset-refs endpoint)
     * @summary Get Asset Variant References Batch
     * @param {BatchAssetRequest} batchAssetRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetVariantReferencesBatchStorageAssetRefsBatchPost(batchAssetRequest: BatchAssetRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getAssetVariantReferencesBatchStorageAssetRefsBatchPost(batchAssetRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return simplified image/video variant URLs for use in design/print (e.g., Figma).  Mapping rules: - Images: thumb -> thumbnail_url, preview -> webview_url or thumbnail_url, print -> original file_url - Videos: hls -> detected master.m3u8, posterThumb -> thumbnail_url, posterPreview -> webview_url or thumbnail_url, print -> original file_url Access scope mirrors /storage/list: if link_id is provided we do not restrict by owner; otherwise owner-only unless admin with mine=false.
     * @summary Get Asset Variant References
     * @param {string | null} [linkId] Group assets by link; bypasses owner scope
     * @param {string | null} [collectionId] Filter by collection_id if link_id not provided
     * @param {number | null} [objectId] Pin to a specific storage object id
     * @param {string | null} [role] Filter by metadata_json.role (e.g., hero|detail|lifestyle)
     * @param {boolean} [mine] 
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetVariantReferencesStorageAssetRefsGet(linkId?: string | null, collectionId?: string | null, objectId?: number | null, role?: string | null, mine?: boolean, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getAssetVariantReferencesStorageAssetRefsGet(linkId, collectionId, objectId, role, mine, limit, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current embedding text for a storage object.
     * @summary Get Embedding Text
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getEmbeddingTextStorageObjectsObjectIdEmbeddingTextGet(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get knowledge graph statistics.  Returns:     Statistics about the knowledge graph including total embeddings,     collection name, and ChromaDB status.
     * @summary Get Kg Stats
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKgStatsStorageKgStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getKgStatsStorageKgStatsGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Serve an optimized media variant directly.  Strategy: - If variant == thumbnail: serve existing thumbnail if present. - If variant == medium or display_for == figma-feed: serve or create a webview-sized derivative (~max 1920px), persist it, and return it. - If variant == full: stream original file. - width/height/format/quality can override defaults and will materialize a persistent derivative in webview dir.
     * @summary Get Media Variant
     * @param {number} objectId 
     * @param {string | null} [variant] thumbnail | medium | full
     * @param {string | null} [displayFor] e.g., figma-feed | web | print
     * @param {number | null} [width] 
     * @param {number | null} [height] 
     * @param {string | null} [format] jpg | png | webp
     * @param {number | null} [quality] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMediaVariantStorageMediaObjectIdGet(objectId: number, variant?: string | null, displayFor?: string | null, width?: number | null, height?: number | null, format?: string | null, quality?: number | null, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getMediaVariantStorageMediaObjectIdGet(objectId, variant, displayFor, width, height, format, quality, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Object Metadata
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getObjectMetadataStorageObjectsObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getObjectMetadataStorageObjectsObjectIdGet(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get O\'Neal product enriched with Storage proxy URLs.  Returns O\'Neal API product data PLUS storage.proxy_url field. This allows Claude and other AI systems to access the cached proxy images.
     * @summary Get Oneal Product Enriched
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnealProductEnrichedStorageOnealProductsProductIdGet(productId: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getOnealProductEnrichedStorageOnealProductsProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get real-time processing status for AI analysis. Shows chunking progress, current stage, timing info.
     * @summary Get Processing Status
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessingStatusStorageObjectsObjectIdProcessingStatusGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getProcessingStatusStorageObjectsObjectIdProcessingStatusGet(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get external proxy cache statistics.  Admin-only endpoint to monitor cache performance.
     * @summary Get Proxy Cache Stats
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProxyCacheStatsStorageProxyStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getProxyCacheStatsStorageProxyStatsGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get public storage object WITHOUT tenant filtering.  This endpoint is for public proxies and does NOT enforce tenant isolation. Only returns objects where is_public=True.  Use this for: - Public proxy access (share.arkturian.com/proxy.php) - Public embed links - Open API access
     * @summary Get Public Object
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPublicObjectStorageObjectsObjectIdPublicGet(objectId: number, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getPublicObjectStorageObjectsObjectIdPublicGet(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get status of an async processing task.  Returns task info including: - status: queued, processing, completed, failed - progress: 0-100 - current_phase: which phase is currently running - result: final results when completed - error: error message if failed
     * @summary Get Task Status
     * @param {string} taskId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskStatusStorageTasksTaskIdGet(taskId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getTaskStatusStorageTasksTaskIdGet(taskId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check for knowledge graph system.  Returns:     Health status including OpenAI configuration and ChromaDB connectivity.
     * @summary Kg Health Check
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kgHealthCheckStorageKgHealthGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).kgHealthCheckStorageKgHealthGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Semantic search across assets by text query using the Knowledge Graph vector store.  Scoping: - Admin: global unless mine=true, then owner-only - Non-admin: tenant-scoped by API key (preferred), else owner email domain; if mine=true, owner-only
     * @summary Kg Text Search
     * @param {string} query Text to search by
     * @param {number} [limit] 
     * @param {string | null} [collectionLike] Optional filter: collection id contains
     * @param {boolean} [mine] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kgTextSearchStorageKgSearchGet(query: string, limit?: number, collectionLike?: string | null, mine?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).kgTextSearchStorageKgSearchGet(query, limit, collectionLike, mine, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Like Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public likeObjectStorageObjectsObjectIdLikePost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).likeObjectStorageObjectsObjectIdLikePost(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Objects
     * @param {boolean} [mine] 
     * @param {string | null} [context] 
     * @param {string | null} [collectionId] 
     * @param {string | null} [collectionLike] Case-insensitive contains filter for collection_id (use %25 for % wildcards)
     * @param {string | null} [linkId] 
     * @param {string | null} [ext] Filter by original_filename extension, e.g. \&#39;png\&#39;
     * @param {string | null} [name] Filter by filename (contains, case-insensitive)
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listObjectsStorageListGet(mine?: boolean, context?: string | null, collectionId?: string | null, collectionLike?: string | null, linkId?: string | null, ext?: string | null, name?: string | null, limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).listObjectsStorageListGet(mine, context, collectionId, collectionLike, linkId, ext, name, limit, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List O\'Neal products enriched with Storage proxy URLs.
     * @summary List Oneal Products Enriched
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listOnealProductsEnrichedStorageOnealProductsGet(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).listOnealProductsEnrichedStorageOnealProductsGet(limit, offset, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all async processing tasks (most recent first).  Optional query parameters: - object_id: Filter tasks for a specific storage object  Useful for monitoring and debugging.
     * @summary List Tasks
     * @param {number} [limit] 
     * @param {number} [objectId] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTasksStorageTasksGet(limit?: number, objectId?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).listTasksStorageTasksGet(limit, objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transparent proxy for external storage objects.  Fetches file from external URI (storage_mode=\"external\") with LRU caching. Returns the file data with appropriate headers.  Access control: - Owner can always access - Public files accessible to all - Admin can access all  Cache configuration (via environment): - EXTERNAL_CACHE_DIR: Cache directory - EXTERNAL_CACHE_MAX_SIZE_MB: Max cache size (default: 500MB) - EXTERNAL_CACHE_MAX_FILES: Max cached files (default: 1000) - EXTERNAL_CACHE_TTL_HOURS: Cache TTL (default: 24h)
     * @summary Proxy External File
     * @param {number} objectId 
     * @param {boolean} [noCache] Bypass cache and fetch fresh from source
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proxyExternalFileStorageProxyObjectIdGet(objectId: number, noCache?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).proxyExternalFileStorageProxyObjectIdGet(objectId, noCache, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace File
     * @param {number} objectId 
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replaceFileStorageFilesObjectIdPut(objectId: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).replaceFileStorageFilesObjectIdPut(objectId, file, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the embedding text and regenerate the Knowledge Graph embedding.  Request body: {     \"embedding_text\": \"New descriptive text for semantic search...\" }
     * @summary Update Embedding Text
     * @param {number} objectId 
     * @param {object} body 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut(objectId: number, body: object, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).updateEmbeddingTextStorageObjectsObjectIdEmbeddingTextPut(objectId, body, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Object Metadata
     * @param {number} objectId 
     * @param {StorageObjectUpdate} storageObjectUpdate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateObjectMetadataStorageObjectsObjectIdPatch(objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).updateObjectMetadataStorageObjectsObjectIdPatch(objectId, storageObjectUpdate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload File
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {string | null} [context] 
     * @param {boolean} [isPublic] 
     * @param {string | null} [ownerEmail] 
     * @param {string | null} [collectionId] 
     * @param {string | null} [linkId] 
     * @param {boolean} [analyze] 
     * @param {string | null} [referenceId] 
     * @param {boolean} [hlsResult] 
     * @param {boolean} [skipAiSafety] 
     * @param {string} [storageMode] 
     * @param {string | null} [referencePath] 
     * @param {string | null} [externalUri] 
     * @param {string | null} [aiFilePath] 
     * @param {string | null} [aiMetadata] 
     * @param {string | null} [aiContextText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadFileStorageUploadPost(file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, skipAiSafety?: boolean, storageMode?: string, referencePath?: string | null, externalUri?: string | null, aiFilePath?: string | null, aiMetadata?: string | null, aiContextText?: string | null, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).uploadFileStorageUploadPost(file, xAPIKEY, context, isPublic, ownerEmail, collectionId, linkId, analyze, referenceId, hlsResult, skipAiSafety, storageMode, referencePath, externalUri, aiFilePath, aiMetadata, aiContextText, options).then((request) => request(this.axios, this.basePath));
    }
}

